/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getAllReleaseProgressionsForReleasePipelineOverrides';
import type { GetAllReleaseProgressionsForReleasePipelineQueryParams } from '../../operation-overrides/getAllReleaseProgressionsForReleasePipelineOverrides';

export type GetAllReleaseProgressionsForReleasePipelinePathParams = NonNullable<
  operations['getAllReleaseProgressionsForReleasePipeline']['parameters']['path']
>;
export type { GetAllReleaseProgressionsForReleasePipelineQueryParams };

export interface Input extends GetAllReleaseProgressionsForReleasePipelinePathParams {
  apiVersion?: string;
  query?: GetAllReleaseProgressionsForReleasePipelineQueryParams;
}

/** @deprecated */
export async function getAllReleaseProgressionsForReleasePipeline(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/release-pipelines/{pipelineKey}/releases', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
